import { Component, EventEmitter, Input, Output, ViewChild, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'success-modal',
    templateUrl: './success-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbModalModule]
})
export class SuccessModalComponent {
  @Input() message?: string;
  @Input() header?: string;

  @ViewChild('modalDiv') modalDiv: TemplateRef<any>;
  modal: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  open(message?: string) {
    this.message = message || this.message;
    this.modal = this.modalService.open(this.modalDiv);
  }

  async onModalClose() {
    this.onAcknowledged.emit();
  }

  @Output() onAcknowledged = new EventEmitter();
}
